import cx from 'classnames';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Phone = ({ children, className }: Props) => {
  return (
    <div className="relative">
      <div className="absolute -left-0.2 top-16 h-6 w-0.5 rounded-l-sm bg-wt-primary" />
      <div className="absolute -left-0.2 top-28 h-8 w-0.5 rounded-l-sm bg-wt-primary" />
      <div className="absolute -left-0.2 top-40 h-8 w-0.5 rounded-l-sm bg-wt-primary" />
      <div className="h-128 w-64 overflow-hidden rounded-4xl bg-wt-primary p-1">
        <div className="relative h-full w-full overflow-hidden rounded-4xl bg-black p-2">
          <div className="absolute left-1/2 h-6 w-28 -translate-x-1/2 transform rounded-b-2xl bg-black" />
          <div className={cx('h-full w-full rounded-3xl', className)}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Phone;
